// Find the size of the first matched element
r.prototype.size = function() {
    return this.first().getBoundingClientRect();
};
